<!-- CountryReadonlyInput.vue -->
<template>
  <div :class="['country-input-container', containerClass]">
    <!-- <label class="country-label">País</label> -->
    <div class="input-wrapper">
      <div class="country-display">
        <img :src="utils.getFlagUrl('MX')" alt="México" />
        <span class="country-name">México</span>
      </div>
      <input
        type="text"
        value="México"
        readonly
        class="hidden-input"
      />
    </div>
  </div>
</template>

<script>
import utils from '../composables/utils';

export default {
  name: 'CountryReadonlyInput',
  props: {
    containerClass: {
      type: [String, Array, Object],
      default: ''
    }
  },
  data () {
    return {
        utils: utils,
    }
  },
};
</script>

<style scoped>
.country-input-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.input-wrapper {
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #e5e4e4;
  padding: 6px 10px;
  min-height: 51px;
}

.country-display {
  display: flex;
  align-items: center;
  gap: 8px;
}

.country-display img {
  width: 20px;
  height: 14px;
}

.hidden-input {
  display: none;
}

.country-label {
  margin-bottom: 4px;
  font-size: 14px;
  color: #555;
}
</style>
